import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"height":"180px"},
  class: "d-flex justify-center align-center"
}
const _hoisted_2 = {
  key: 2,
  style: {"height":"180px"},
  class: "d-flex justify-center align-center"
}
const _hoisted_3 = { style: {"word-break":"break-all"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      onClick: _ctx.onClickCard,
      disabled: _ctx.loading
    }, {
      default: _withCtx(() => [
        (_ctx.content.status == 'completed')
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 0,
              src: _ctx.content.thumbnailUrl || '',
              sizes: "180px",
              height: "180px"
            }, null, 8, ["src"]))
          : (_ctx.content.status == 'failed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_chip, {
                  small: "",
                  color: "error"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode(" 失敗 ", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_chip, {
                  small: "",
                  color: "secondary"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" 処理中 ", -1)
                  ]))]),
                  _: 1
                })
              ])),
        _createVNode(_component_v_card_text, { class: "pa-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { align: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_table, { density: "compact" }, {
                          default: _withCtx(() => [
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _cache[4] || (_cache[4] = _createElementVNode("td", null, "種類", -1)),
                                _createElementVNode("td", null, [
                                  (_ctx.content.category == 'photo')
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        small: "",
                                        color: "success"
                                      }, {
                                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                          _createTextVNode("写真", -1)
                                        ]))]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        dark: "",
                                        small: "",
                                        color: "purple"
                                      }, {
                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                          _createTextVNode(_toDisplayString(`動画`), -1)
                                        ]))]),
                                        _: 1
                                      }))
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[5] || (_cache[5] = _createElementVNode("td", null, "撮影日", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.content.date)), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[6] || (_cache[6] = _createElementVNode("td", null, "単価", -1)),
                                _createElementVNode("td", null, _toDisplayString(`¥${_ctx.content.price}`), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[7] || (_cache[7] = _createElementVNode("td", null, "購入数", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.content.purchasedCount), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("td", null, "売上", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.content.revenue), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("td", null, "ファイル名", -1)),
                                _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.content.filename), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("td", null, "シリアルNO", -1)),
                                _createElementVNode("td", null, _toDisplayString(_ctx.content.serialNumber), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick", "disabled"])
  ]))
}